class Accordion {
    constructor() {
        this.accordionItems = document.querySelectorAll('.accordian-block__item');
        this.init();
    }

    init() {
        this.accordionItems.forEach(item => {
            const title = item.querySelector('.accordian-block__title');
            const content = item.querySelector('.accordian-block__content');
            const contentInner = item.querySelector('.accordian-block__content-inner');

            // Set initial height to 0
            content.style.height = '0px';

            title.addEventListener('click', () => this.toggleAccordion(item, content, contentInner));
        });
    }

    toggleAccordion(item, content, contentInner) {
        const isOpen = item.classList.contains('active');

        this.accordionItems.forEach(otherItem => {
            if (otherItem !== item && otherItem.classList.contains('active')) {
                const otherContent = otherItem.querySelector('.accordian-block__content');
                otherItem.classList.remove('active');
                otherContent.style.height = '0px';
            }
        });

        if (!isOpen) {
            item.classList.add('active');
            content.style.height = contentInner.offsetHeight + 'px';
        } else {
            item.classList.remove('active');
            content.style.height = '0px';
        }
    }
}

// Initialize accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new Accordion();
});
